import React, { useState } from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import { LuX } from "react-icons/lu";
import UploadComponent from "../../external_provider/file_modal/APIProviders/providers/UploadComponent";
import ZipImportModal from "../../canvas/editor_box/screen_training/importer/ZipImportModal";

const UploadFilesPanel = (props) => {
  const {
    isClm,
    isBusy,
    filesUploaded,
    uploadFunction,
    onNavItemsAdded,
    onIndexSelected,
    onNavItemSelected,
    navItemsIds,
    navItems,
    navItemSelected,
    containedViews,
    containedViewSelected,
    boxes,
    onBoxAdded,
    fileModalResult,
    onElementSelected,
    onClose,
  } = props;

  const [activeTab, setActiveTab] = useState("files"); // "files" | "zip"
  // CLM courses: Screen Training ZIP import inserts GuideMultiInput/
  // GuideTagDisplay, neither allowlisted (common/clm.es6) — same gate as the
  // Templates modal's "Screen Training" tab.
  const isZipTab = activeTab === "zip" && !isClm;

  return (
    <div
      className="library-upload-panel"
      style={{
        flex: 1,
        maxHeight: "calc(100vh - 105px)",
        padding: "0 10px",
        overflowY: "auto",
        overflowX: "hidden",
        color: "#6B7280",
        fontSize: 13,
        position: "relative",
      }}
    >
      {onClose && (
        <button
          type="button"
          className="cmp-panel__close"
          onClick={onClose}
          title={i18n.t("close") || "Kapat"}
          style={{ position: "absolute", top: 8, right: 8, zIndex: 10 }}
        >
          <LuX size={15} />
        </button>
      )}

      <div className="templates-modal__tabs">
        <button
          type="button"
          className={activeTab === "files" ? "active" : ""}
          onClick={() => setActiveTab("files")}
        >
          {i18n.t("ZipImport.tab_upload") || "Dosya Yükle"}
        </button>
        {!isClm && (
          <button
            type="button"
            className={activeTab === "zip" ? "active" : ""}
            onClick={() => setActiveTab("zip")}
          >
            {i18n.t("ZipImport.tab_screen") || "Ekran Eğitimi"}
          </button>
        )}
      </div>

      {isZipTab ? (
        <ZipImportModal
          showScenePicker
          onImportComplete={onClose}
          onBoxAdded={onBoxAdded}
          boxes={boxes}
        />
      ) : (
        <UploadComponent
          show="*"
          isClm={isClm}
          isBusy={isBusy}
          filesUploaded={filesUploaded}
          uploadFunction={uploadFunction}
          onNavItemsAdded={onNavItemsAdded}
          onIndexSelected={onIndexSelected}
          onNavItemSelected={onNavItemSelected}
          navItemsIds={navItemsIds}
          navItems={navItems}
          navItemSelected={navItemSelected}
          containedViews={containedViews}
          containedViewSelected={containedViewSelected}
          boxes={boxes}
          onBoxAdded={onBoxAdded}
          fileModalResult={fileModalResult}
          onElementSelected={onElementSelected || (() => {})}
          idSelected={null}
          pdfSelected={false}
          closeSideBar={() => {}}
        />
      )}
    </div>
  );
};

UploadFilesPanel.propTypes = {
  isClm: PropTypes.bool,
  isBusy: PropTypes.any,
  filesUploaded: PropTypes.any,
  uploadFunction: PropTypes.func.isRequired,
  onNavItemsAdded: PropTypes.func.isRequired,
  onIndexSelected: PropTypes.func.isRequired,
  onNavItemSelected: PropTypes.func.isRequired,
  navItemsIds: PropTypes.array.isRequired,
  navItems: PropTypes.object.isRequired,
  navItemSelected: PropTypes.any,
  containedViews: PropTypes.object.isRequired,
  containedViewSelected: PropTypes.any,
  boxes: PropTypes.object.isRequired,
  onBoxAdded: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};

export default UploadFilesPanel;
